export default __webpack_public_path__ + "static/media/berifcase.32b34600.svg";